<template>
  <heading tag="h1" icon="library">{{ library.title }}</heading>
  <LbBlockLibraryBook :library-book="library.children[0]" />
</template>
<script lang="ts" setup>
const {
  libraryManager: { library },
} = inject(INJECT_LIBRARY_PAGE_OR_FORM);
</script>
